<template>
  <v-flex fluid fill-height grow class="sidebar" :class="open ? 'open' : ''">
    <v-layout row class="sidebar-container">
      <v-flex v-show="open" class="sidebar-content">
        <v-layout justify-left class="sidebar-toolbar">
          <v-list class="dash-list">
            <v-subheader class="ml-3">REPORTS</v-subheader>
            <div v-for="(link, i) in links" :key="i">
              <v-list-item
                  v-if="!link.subLinks"
                  :key="i"
                  v-on:click="setDashboardComponent(link.board)"
              >
                <v-list-item-action class="ml-4">
                  <v-icon color="#e7511e">{{ link.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title v-text="link.text" />
              </v-list-item>

              <v-list-group
                v-else
                :key="link.text"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-action>
                    <v-icon color="#e7511e">{{ link.icon }}</v-icon>
                  </v-list-item-action>
                    <v-list-item-content>                                          
                      <v-list-item-title>{{ link.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <v-list-item
                    v-for="sublink in link.subLinks"
                    :key="sublink.text"
                    v-on:click="setDashboardComponent(sublink.board)"
                >
                  <v-list-item-action>
                    <v-icon color="#e7511e">{{ sublink.icon }}</v-icon>
                  </v-list-item-action>              
                  <v-list-item-title v-text="sublink.text" />
                </v-list-item>
              </v-list-group>
            </div>
          </v-list>
        </v-layout>
      </v-flex>
      <v-flex class="sidebar-activator" v-on:click="activatorClicked()">
        <div>
          <v-icon
            medium
            class="ml-1"
            color="white"
          >{{open ? 'chevron_left' : 'chevron_right'}}</v-icon>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'sidebar',
  data() {
    return {
      open: false,
      links: [
        {
          icon      : 'mdi-calendar-clock',
          text      : 'Toggl Hours',
          board     : 'hours',
          adminOnly : false
        },
        {
          icon      : 'mdi-ruler',
          text      : 'Levelling Data',
          board     : 'levelling',
          adminOnly : false
        },
        {
          icon      : 'mdi-car',
          text      : 'Incident Report',
          board     : 'incidentreport',
          adminOnly : false
        }, 
        {
          icon      : 'mdi-folder-multiple-outline',
          text      : 'Carbine',
          board     : null,
          adminOnly : true,
          subLinks : [
            {
              text  : 'Projects',
              icon  : 'mdi-folder-multiple',
              board : 'carbine-projects'
            },
            {
              text  : 'New Project',
              icon  : 'mdi-folder-plus',
              board : 'carbine-new-project'
            },
            {
              text  : 'New Proposal',
              icon  : 'mdi-folder-plus',
              board : 'carbine-new-proposal'
            },
            {
              text  : 'New Client',
              icon  : 'mdi-plus-circle-outline',
              board : 'carbine-new-client'
            },            
          ]
        }
      ]     
    };
  },
  mounted() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    if (!this.$store.state.user.admin) {
      this.links = this.links.filter(l => !l.adminOnly)
    }
  }, 
  methods: {
    activatorClicked() {
      this.open = !this.open;
    },
    setDashboardComponent(dash){
      this.$store.dispatch('setDash', dash)
      this.open = !this.open;
    }
  }
}
</script>

<style scoped>

.sidebar-toolbar .v-btn.active {
  background-color: #e7511e;
}

.sidebar-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  z-index: 1000;
}

.sidebar {
  position: relative;
}

.sidebar {
  max-width: 32px !important;
  min-width: 32px;
}

.sidebar.open {
  min-width: 330px;
  max-width: 330px;
}

.sidebar .layout {
  flex-grow: 1;
  width: 100%;
}

.sidebar-content {
  background-color: #fff;
  position: relative;
  height: 100%;
}

.sidebar-activator {
  min-width: 32px;
  max-width: 32px !important;
  background-color: #41281b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}

.sidebar-activator:hover {
  background-color: #41281b;
}

.sidebar-activator .v-icon {
  width: 32px;
  text-align: center;
}

.dash-list {
  width: 100%;
  text-align: left;
}

.dash-list .v-icon {
  margin-left: 10px;
}

</style>